import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_2 = { class: "col-span-6" }
const _hoisted_3 = { class: "grid grid-cols-6 gap-6" }
const _hoisted_4 = { class: "md:col-span-3 col-span-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 md:block hidden" }, null, -1)
const _hoisted_6 = { class: "md:col-span-3 col-span-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 md:block hidden" }, null, -1)
const _hoisted_8 = { class: "md:col-span-3 col-span-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 md:block hidden" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "md:col-span-3 col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 md:block hidden" }, null, -1)
const _hoisted_12 = { class: "md:col-span-3 col-span-6" }
const _hoisted_13 = { class: "flex items-center justify-end w-full space-x-3" }
const _hoisted_14 = { href: "/personnel/index/" }

import { ref } from 'vue';
import TextInput from '@/components/inputs/TextInput.vue';
import PasswordInput from '@/components/inputs/PasswordInput.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';

import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';
import SuccessModal from '@/components/modals/SuccessModal.vue';


import Profile from "@/classes/Profile";
import { errorResponse } from "@/helpers/errorMessage";

import PageLoader from "@/components/loaders/PageLoader.vue"

import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  setup(__props) {

const router = useRouter();

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const loading = ref<boolean>(false);

const errors = ref<any>();

const form = ref<{
    current_password: string | null;
    new_password: string | null;
    new_password_confirmation: string | null;
}>({
    current_password: null,
    new_password: null,
    new_password_confirmation: null,
});


const submit = (): void => {
    showConfirmation.value = false
    loading.value = true
    Profile.editPassword(form.value).then(() => {
        showSuccess.value = true;
        loading.value = false;
    })
    .catch((error: any) => {
        errors.value = errorResponse(error.response?.data?.errors)
    })
}

const confirm = (): void => {
    location.reload()
    
    showSuccess.value = false;
    form.value.current_password = null;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(PasswordInput, {
            label: "Current Password",
            placeholder: "Current Password",
            name: "current-password",
            id: "current-password",
            modelValue: form.value.current_password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.current_password) = $event)),
            error: errors.value?.current_password
          }, null, 8, ["modelValue", "error"])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(PasswordInput, {
            label: "New Password",
            placeholder: "New Password",
            name: "new-password",
            id: "new-password",
            modelValue: form.value.new_password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.new_password) = $event)),
            error: errors.value?.new_password
          }, null, 8, ["modelValue", "error"])
        ]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(PasswordInput, {
            label: "Retype New Password",
            placeholder: "Retype New Password",
            name: "confirm-password",
            id: "confirm-password",
            modelValue: form.value.new_password_confirmation,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.new_password_confirmation) = $event)),
            error: errors.value?.new_password_confirmation
          }, null, 8, ["modelValue", "error"])
        ]),
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", _hoisted_14, [
              _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              })
            ]),
            _createVNode(ButtonComponent, {
              btnWidth: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showConfirmation.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save Changes")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showConfirmation.value,
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (submit())),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Save Details",
      content: "Are you sure you wish to save this detail?"
    }, null, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => (confirm() )),
      "action-text": "Close",
      title: "Password Updated!",
      content: "Password has been successfully updated"
    }, null, 8, ["show"]),
    _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
  ]))
}
}

})